import Mixpanel from 'mixpanel-browser';

if (process.env.NODE_ENV === 'production') {
  Mixpanel.init('000837cf19154e1b894a408b012d15c4');
}

const logMixpanelEvent = tag => {
  if (process.env.NODE_ENV === 'production') {
    Mixpanel.track(tag);
  }
};

export { logMixpanelEvent };
